import { render, staticRenderFns } from "./KAM002-v1.vue?vue&type=template&id=77789336"
import script from "./KAM002-v1.vue?vue&type=script&lang=ts"
export * from "./KAM002-v1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports